import { INSPECTIONS_FILTER_REMOVE } from "redux/types";
import inspectionsLoad from "./inspectionsLoad";

export default function inspectionsFilterRemove(filterName) {
    return async (dispatch) => {
        await dispatch({ type: INSPECTIONS_FILTER_REMOVE, filterName });
        dispatch(inspectionsLoad());
    };
}